export enum FilterGroupType {
  Checkbox = 'Checkbox',
  Range = 'Range',
  PriceRange = 'PriceRange',
}
